import { tap } from 'rxjs';
import { action$, dispatchAction, ofType, withNamespace } from '@ardoq/rxbeach';
import { setIsSelectAll } from '@ardoq/dropdown-menu';
import { selectionEnd } from '../../actions/navigatorActions';
import { GetAdditionalRoutineArgs } from '../../types';

export const getClearSelectAllOnRangeSelectRoutine = ({
  navigatorConfiguration,
}: GetAdditionalRoutineArgs) =>
  action$.pipe(
    withNamespace(navigatorConfiguration.actionNamespace),
    ofType(selectionEnd),
    tap(() => dispatchAction(setIsSelectAll(false)))
  );
